import { INSTALLABLE_BRIDGE_AGENTS } from '@buildautomaton/types';
import { ensureBridgeAgentPathInProcessEnv } from '../acp/clients/bridge-agent-path.js';
import { waitForCommandOnPath } from '../acp/clients/detect-command-on-path.js';
import { getAgentInstallCommand } from './commands/index.js';

export async function installLocalAgentOnBridge(params: {
  agentType: string;
  authToken: string;
  onProgress?: (message: string, logOutput?: string) => void;
}): Promise<{ success: boolean; error?: string }> {
  const spec = INSTALLABLE_BRIDGE_AGENTS.find((a) => a.value === params.agentType);
  if (!spec) return { success: false, error: `Unsupported agent type: ${params.agentType}` };

  const command = getAgentInstallCommand(params.agentType);
  if (!command) return { success: false, error: `No install command for ${params.agentType}` };

  params.onProgress?.(`Configuring ${spec.label} credentials`);

  try {
    await command.install({
      authToken: params.authToken,
      onProgress: params.onProgress,
      env: { ...process.env, [spec.tokenEnvVar]: params.authToken },
    });
  } catch (e) {
    const msg = e instanceof Error ? e.message : String(e);
    return { success: false, error: msg };
  }

  ensureBridgeAgentPathInProcessEnv();
  const detectNames = [
    command.detectCommand,
    ...(command.alternateDetectCommands ?? []),
  ];
  let found = false;
  for (const name of detectNames) {
    if (await waitForCommandOnPath(name)) {
      found = true;
      break;
    }
  }
  if (!found) {
    return { success: false, error: `${command.detectCommand} not found on PATH after install` };
  }

  return { success: true };
}
